import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"
import {store} from "core-js/internals/reflect-metadata";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        order: {
            buyType: "",
            payType: "",
            vip: {
                monthNumber: 0,
                account: "",
                payment: "",
                currency: "",
                isHot: true,
                gcode: "",
                payCode: "",
                save: ''
            },
            pb: {
                pbNumber: 0,
                account: "",
                payment: "",
                currency: "",
                gcode: "",
                payCode: "",
                pbImgUrl: ""
            },
            orderNo: ""
        },
        language: null,
        homePath: "https://www.pocketfx.net/"
    },
    getters: {},
    mutations: {
        changePbData(state, pb) {
            state.order.pb = pb
        },
        changePayType(state, type) {
            state.order.payType = type
        },
        changePbVip(state, vip) {
            state.order.vip = vip
        },
        changeBuyType(state, type) {
            state.order.buyType = type
        },
        changeLanguage(state, language) {
            state.language = language
        },
        changeHomePath(state, path) {
            state.homePath = path
        },
        changeOrderPb(state, pb) {
            state.order.pb = pb
        },
        changeOrderVip(state, vip) {
            state.order.vip = vip
        },
        changeOrderNo(state, orderNo) {
            state.order.orderNo = orderNo
        }
    },
    actions: {},
    modules: {},
    plugins: [createPersistedState({
        storage: window.sessionStorage
    })]
})
